<template>
    <div class="last-viewed" v-if="items.length">
        <div class="last-viewed__title text_15 text_bold">{{ $t("Вы просматривали") }}</div>
        <div class="last-viewed__content">
            <swiper :options="sliderOptions">
                <swiper-slide v-for="(product, index) in items" :key="product.id" :index="index + 1">
                    <Product is-for-slider :data="product"></Product>
                </swiper-slide>
                <div v-if="!this.$device.isMobile" slot="button-prev" class="splide__arrow splide__arrow--prev"></div>
                <div v-if="!this.$device.isMobile" slot="button-next" class="splide__arrow splide__arrow--next"></div>
            </swiper>
        </div>
    </div>
</template>
<script>
import Product from "@/components/Product";
import { Swiper, SwiperSlide } from "@/plugins/swiper.client";

export default {
    name: "LastViewed",
    components: { Product, Swiper, SwiperSlide },
    data() {
        return {
            items: [],
            sliderOptions: {
                slidesPerView: this.$device.isMobile ? 2 : 3,
                navigation: {
                    nextEl: ".splide__arrow--next",
                    prevEl: ".splide__arrow--prev",
                },
            },
        };
    },
};
</script>
<style lang="less">
.last-viewed {
    &__title {
        padding: 32px 32px 16px;
    }
}

.splide__arrow {
    -ms-flex-align: center;
    align-items: center;
    background: #ccc;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    opacity: 0.7;
    padding: 0;
    position: absolute;
    top: 50%;
    z-index: 1;
    width: 43px;
    height: 43px;
    transform: translateY(-22px);
    filter: grayscale(1) brightness(0);
    .trs(all);
    &:hover {
        filter: grayscale(0) brightness(1);
        opacity: 1;
    }
    svg {
        display: none;
    }
    &--prev {
        left: 16px;
        background: url(../assets/icons/splide-prev-arrow.svg) center / 43px 43px no-repeat;
    }
    &--next {
        right: 16px;
        background: url(../assets/icons/splide-next-arrow.svg) center / 43px 43px no-repeat;
    }
}

.swiper-slide {
    height: auto;
}
</style>
